<template>
  <div class="login">
    <div class="swiper"><img src="../img/login_bg.png" alt="" /></div>
    <!-- 登录 -->
    <div v-show="login" class="logins">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="手机登录" name="first">
          <div class="inputs">
            <el-input
              placeholder="请输入手机号"
              maxlength="11"
              @input="pnumber"
              prefix-icon="el-icon-phone-outline"
              v-model="phonenumber"
            ></el-input>
            <div class="verify">
              <el-input
                autocomplete="off"
                style="margin-top: 0px"
                placeholder="请输入验证码"
                prefix-icon="el-icon-key"
                v-model="phonecode"
                maxlength="4"
              ></el-input>
              <div
                @click.stop="sendSmsCode"
                class="zai-checking"
                v-if="state === false"
              >
                获取验证码
              </div>
              <div class="zai-checking zai-time" v-if="state === true">
                倒计时{{ currentTime }}s
              </div>
            </div>
            <!-- <el-input
              placeholder="请输入密码"
              @input="ppassword"
              show-password
              prefix-icon="el-icon-lock"
              v-model="phonepassword"
            ></el-input> -->
          </div>
          <!-- <div class="forget"><span @click.stop="wj()">忘记密码</span></div> -->
          <!-- <div class="guide ma-t-10">
            <el-checkbox @change="guides" v-model="checked"></el-checkbox>
            我同意
            <span @click.stop="fu">《使用条款》</span>
          </div> -->
          <div @click.stop="logins" class="register">登录</div>
          <div @click.stop="register()" class="zhu">注册</div>
        </el-tab-pane>
        <el-tab-pane label="微信登录" name="weixin">
          <div class="t-center">
            <div class="t-center ma-t-20 bold">请使用微信扫一扫登录</div>
            <img :src="LoginQrCode" alt="" srcset=""  width="60%"/>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<style lang="scss" >
.login {
  min-width: 1200px;
  position: relative;
  .swiper {
    height: 610px;
    img {
      width: 100%;
      height: auto;
    }
  }
  .logins {
    width: 358px;
    // height: 400px;
    padding-top: 17px;
    box-sizing: border-box;
    position: absolute;
    right: 20%;
    top: 12%;
    background: #ffffff;
    z-index: 9;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 5px;
    // .find {
    // 	text-align: center;
    // 	font-size: 16px;
    // 	font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    // 	font-weight: bold;
    // 	color: rgba(54, 64, 94, 1);
    // }

    .el-tabs__nav-scroll {
      display: flex;
      margin-left: 50px;
    }
    .el-tabs__item {
      padding: 0 65px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: rgba(153, 153, 153, 1);
    }
    // el-tabs__item is-top is-active
    .is-active {
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #0f75bd;
      // background: linear-gradient(90deg, rgba(49, 114, 255, 1) 0%, rgba(24, 144, 255, 1) 100%);
      // -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
    }
    .el-tabs__nav-wrap::after {
      background-color: #ffffff;
    }
    .inputs {
      width: 306px;
      margin: 10px auto 0px auto;
      .el-input__inner {
        border: none;
        border-radius: 0px;
        border-bottom: 1px solid #e6e6e6;
      }
      .el-input {
        margin-top: 30px;
      }
    }
    .forget {
      width: 306px;
      margin: 18px auto 30px auto;
      text-align: right;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: rgba(153, 153, 153, 1);
      cursor: pointer;
    }
    .forget span:hover {
      color: red;
      font-weight: 600;
    }
    .guide {
      width: 306px;
      margin: 0px auto 9px auto;
      color: rgba(25, 141, 255, 1);
      font-size: 14px;
      font-family: MicrosoftYaHei;
      span {
        cursor: pointer;
        color: rgba(25, 141, 255, 1);
      }

      .el-radio__label {
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: rgba(153, 153, 153, 1);
      }
    }
    .register {
      width: 306px;
      height: 44px;
      margin: 20px auto;
      background: rgba(15, 119, 191, 1);
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 44px;
      text-align: center;
      cursor: pointer;
    }
    .zhu {
      cursor: pointer;

      width: 60px;
      height: 44px;
      margin: 19px auto 10px auto;
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: rgba(25, 141, 255, 1);
      line-height: 44px;
      text-align: center;
    }
    .zhu:hover {
      color: red;
      font-weight: 600;
    }
    .verify {
      height: 40px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 30px;
      .el-input__inner {
        width: 60%;
      }
      .zai-checking {
        height: 40px;
        width: 40%;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        color: #0f75bd;
        cursor: pointer;
      }
    }
  }
}
</style>
<script>
import { phonelogin, getcodes, getLoginQrCode,postScanLogin } from "../api.js";

var _this;
export default {
  name: "Login",
  components: {},
  data() {
    return {
      setIntervalLoginQrCode:{},//计时器，循环查询扫码结果
      LoginKey:'',//微信扫码登录的key
      LoginQrCode: "", //微信扫码登录二维码
      fetch_static: false,
      fetch_static2: false,
      activeName: "first",
      phonenumber: "", //手机登录手机号
      phonepassword: "", //手机登录密码
      checked: true, //勾选条款
      echecked: true,
      emailnumber: "", //邮箱号
      emailpassword: "", //邮箱登录密码
      input2: "",
      radio: 1,
      login: true, //显示登录
      slip: false, //忘记密码显示
      state: false, //是否开启倒计时
      totalTime: 120, //总时间，单位秒
      recordingTime: 0, //记录时间变量
      currentTime: 0, //显示时间变量
      phonecode: "",
      goPage: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0);

    next((vm) => {
      console.log(from)
      if (from.path != "/Register" && from.path != "/Find" && !(from.name==null && from.path=='/')) {
        vm.goPage = true;
      }
    });
  },
  beforeRouteLeave(to,from,next){
    clearInterval(_this.setIntervalLoginQrCode)
    next()
  },
  created() {
    _this=this;
    let phone = localStorage.getItem("phonenumber");
    let emailh = localStorage.getItem("emailnumber");
    this.phonenumber = phone;
    this.emailnumber = emailh;

    //获取微信扫码登录二维码
    getLoginQrCode().then((res) => {
        _this.LoginQrCode = res.data.Data.Url;
        _this.LoginKey = res.data.Data.Key;
      });
  },

  methods: {
    // 手机短信验证码
    sendSmsCode() {
      let that = this;
      let phone = that.phonenumber;
      var reg = 11 && /^((13|14|15|17|18|16|19|11|12)[0-9]{1}\d{8})$/;
      if (phone.length < 1) {
        that.$message.error("手机号不能为空哦！");
        return;
      } else if (!reg.test(phone)) {
        that.$message.error("手机格式不正确！");
        return;
      }
      let phones = { Phone: phone, Source: "pc", Type: "1" };
      getcodes(phones).then((res) => {
        if (res.data.Code == 0) {
          that.$message({
            message: res.data.Data,
            type: "success",
          });
          // 把显示时间设为总时间
          that.currentTime = that.totalTime;
          //开始倒计时
          that.state = true;
          //执行倒计时
          that.checkingTime();
        } else {
          that.$message.error(res.data.Message);
        }
      });
    },
    // 手机号几时
    checkingTime() {
      let that = this;
      //判断是否开启
      if (this.state) {
        //判断显示时间是否已到0，判断记录时间是否已到总时间
        if (this.currentTime > 0 && this.recordingTime <= this.totalTime) {
          //记录时间增加 1
          this.recordingTime = this.recordingTime + 1;
          //显示时间，用总时间 - 记录时间
          this.currentTime = this.totalTime - this.recordingTime;
          //1秒钟后，再次执行本方法
          setTimeout(() => {
            //定时器内，this指向外部，找不到vue的方法，所以，需要用that变量。
            that.checkingTime();
          }, 1000);
        } else {
          //时间已完成，还原相关变量
          this.state = false; //关闭倒计时
          this.recordingTime = 0; //记录时间为0
          this.currentTime = this.totalTime; //显示时间为总时间
        }
      } else {
        //倒计时未开启，初始化默认变量
        this.state = false;
        this.recordingTime = 0;
        this.currentTime = this.totalTime;
      }
    },
    handleClick(tab) {
      console.log(tab.index);
      if(tab.index==1){
       _this.setIntervalLoginQrCode=  setInterval(() => {
          _this.scanQRcodeReult()
        }, 1000);
      }else{
        clearInterval(_this.setIntervalLoginQrCode)
      }
    },
    //微信扫码结果
    scanQRcodeReult(){
      postScanLogin({
        key:_this.LoginKey
      }).then(res=>{
        
        if(res.data.Data.AccessToken){
          //扫码登录成功
          localStorage.setItem("AccessToken", res.data.Data.AccessToken);
            localStorage.setItem("RefreshToken", res.data.Data.RefreshToken);
            localStorage.setItem("AccessTokenTime",res.data.Data.AccessTokenTime
            );
            localStorage.setItem("RefreshTokenTime",res.data.Data.RefreshTokenTime);
            localStorage.setItem("username", res.data.Data.MemberName);

            _this.$message.success('登录成功');
            clearInterval(_this.setIntervalLoginQrCode)

            setTimeout(() => {
              if (this.goPage) {
                _this.$router.go(-1);
              } else {
                _this.$router.push("/");
              }
            }, 1000);
          }



      }).catch((error) => {
          _this.$message.error('失败'+error);
        });
    },
    //忘记密码
    wj() {
      this.$router.push("/Find");
    },

    // 注册
    register() {
      this.$router.push("/Register");
    },
    // 手机号
    pnumber(e) {
      this.phonenumber = e;
    },

    //手机登录密码
    ppassword(e) {
      this.phonepassword = e;
    },

    guides(e) {
      this.fetch_static = false;
      this.checked = e;
    },
    eguides(e) {
      this.echecked = e;
      this.fetch_static2 = false;
    },

    //手机号登录
    logins() {
      let that = this;

      let phone = that.phonenumber;
      let phonepassword = that.phonepassword;
      let reg = 11 && /^((13|14|15|17|18|16|19|11|12)[0-9]{1}\d{8})$/;
      if (phone.length < 1) {
        that.$message.error("手机号不能为空哦");
        return;
      } else if (!reg.test(phone)) {
        that.$message.error("手机格式不正确");
        return;
      }
      if (!that.checked) {
        that.$message.error("请勾选服务条款");
        return;
      }
      if (that.phonecode == "") {
        that.$message.error("请输入验证码");
        return;
      }

      if (/[\u4E00-\u9FA5]/g.test(phonepassword)) {
        that.$message.error("密码不能有汉字");
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: "提交中",
        spinner: "el-icon-loading",
        background: "#0000000",
      });
      let data = {
        Phone: phone,
        // Password: phonepassword,
        Code: that.phonecode,
        Source: "web",
        Type: "1",
      };

      console.log(data);

      phonelogin(data)
        .then((res) => {
          if (res.data.Code == 0) {
            localStorage.setItem("AccessToken", res.data.Data.AccessToken);
            localStorage.setItem("RefreshToken", res.data.Data.RefreshToken);
            localStorage.setItem(
              "AccessTokenTime",
              res.data.Data.AccessTokenTime
            );
            localStorage.setItem(
              "RefreshTokenTime",
              res.data.Data.RefreshTokenTime
            );
            localStorage.setItem("phonenumber", phone);
            localStorage.setItem("password", phonepassword);
            localStorage.setItem("username", res.data.Data.MemberName);

            that.$message({
              message: res.data.Message,
              type: "success",
              center: true,
              duration: 1000,
              customClass: "sps",
            });
            loading.close();

            setTimeout(() => {
              if (this.goPage) {
                that.$router.go(-1);
              } else {
                that.$router.push("/");
              }
            }, 1000);
          } else {
            loading.close();
            that.fetch_static = false;
            that.$message({
              message: res.data.Message,
              type: "warning",
              center: true,
              customClass: "sps",
            });
          }
        })
        .catch((error) => {
          loading.close();
          that.fetch_static = false;
          console.log("失败" + error);
        });
    },
  },
};
</script>
